// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import {
  getCartOrderList,
  getIsCartItemsUpdating,
  getIsCartItemsSFL,
  getIsSflItemRemoved,
  getIsSflItemMovedToBag,
  getOrderShipments,
  getStoreLoadingState,
  getStoreUpadateCompetedState,
  getshipmentProductInventory,
  getNonBopisCartProductIdsWithQty,
  getScrollToTile,
  getHasBopisItems,
  orderIncludesPreOrderItemsOfItemOrVarientLevel,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { setDefaultStore } from '@tcp/core/src/components/features/account/User/container/User.actions';
import { updateDeliveryMethodSelection } from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions';
import { getEnableFullPageAuth } from '@tcp/web/src/components/features/content/HomePage/HomePage.selectors';
import { openOverlayModal } from '@tcp/core/src/components/features/account/OverlayModal/container/OverlayModal.actions';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import {
  getDefaultStoreData,
  getUserLoggedInState,
  isPlccUser,
  isRememberedUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import * as sessionSelectors from '@tcp/core/src/reduxStore/selectors/session.selectors';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import CheckoutSelector from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { getOrderEddDates } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.selectors';
import { isMobileWeb } from '@tcp/core/src/utils';
import {
  updateCartItem,
  confirmRemoveCartItem,
  updateStoreItem,
  setStoreUpdateCompletedState,
  getShipmentProductInventoryData,
  scrollToTile,
} from '../../../container/CartItemTile.actions';
import ProductTileWrapper from '../views/ProductTileWrapper.view';
import BAG_SELECTORS, {
  getBossStatus,
  getFreeShippingThresholdValue,
  getLoyaltyPointsRequestPayload,
  getOrderType,
} from '../../../../BagPage/container/BagPage.selectors';
import { setClickAnalyticsData, trackClick } from '../../../../../../../analytics/actions';
import { openPickupModalWithValues } from '../../../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import getGroupedItems from './ProductTileWrapper.selectors';
import {
  moveItemsToBossUnavailableList,
  setBossUnavailableProductInList,
} from '../../../molecules/BossUnavailableTile/container/BossUnavailable.actions';
import {
  getProductTotal,
  getShippingTotal,
} from '../../../../common/organism/OrderLedger/container/orderLedger.selector';
import { setDefaultBanner } from '../../../../BagPage/container/BagPage.actions';
import BagpageUtils from '../../../../BagPage/views/Bagpage.utils';

const usePrevious = (value) => {
  const ref = useRef([]);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export const ProductTileWrapperContainer = (props) => {
  const {
    getShipmentProductInventory,
    isMiniBag,
    isBopisEnabled,
    userDefaultStore,
    nonBopisData,
    groupedItems,
    isBopisInventorySwitchEnabled,
    hasBopisItems,
    moveItemsToBossUnavailableListAction,
    bossUnavailableProducts,
    isBossCart,
    bossUnavailableSwitch,
    isSiteWidePromoBannerAbTestEnabled,
    isExtendedHolidayReturnsBannerAbTestEnabled,
    isHolidayGetItByMessageBannerAbTestEnabled,
    isDefaultSocialProofBanner,
    setDefaultBannerAction,
    timerDeadlineValue,
    isDesktopProductTileCleanUpDisabled,
    isMobileWebTileEnhancementEnabled,
  } = props;
  const { basicInfo: { id = '' } = {} } = userDefaultStore || {};
  const flagCheck =
    (isBopisInventorySwitchEnabled || hasBopisItems) && id && isBopisEnabled && !isMiniBag;
  const prevNonBopisData = usePrevious(nonBopisData);
  useEffect(() => {
    if (
      flagCheck &&
      nonBopisData.length >= prevNonBopisData.length &&
      !isEqual(nonBopisData, prevNonBopisData)
    ) {
      getShipmentProductInventory();
    }
  }, [nonBopisData, userDefaultStore]);

  const isDeadlinePassed = BagpageUtils.isDeadlinePassed(
    timerDeadlineValue,
    isExtendedHolidayReturnsBannerAbTestEnabled
  );
  return (
    <>
      <ProductTileWrapper
        groupedItems={groupedItems}
        isMobileWebProductTile={isMobileWeb()}
        moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
        bossUnavailableProducts={bossUnavailableProducts}
        isBossCart={isBossCart}
        bossUnavailableSwitch={bossUnavailableSwitch}
        isSiteWidePromoBannerAbTestEnabled={isSiteWidePromoBannerAbTestEnabled}
        isExtendedHolidayReturnsBannerAbTestEnabled={isExtendedHolidayReturnsBannerAbTestEnabled}
        isHolidayGetItByMessageBannerAbTestEnabled={isHolidayGetItByMessageBannerAbTestEnabled}
        isDefaultSocialProofBanner={isDeadlinePassed || isDefaultSocialProofBanner}
        setDefaultBannerAction={setDefaultBannerAction}
        timerDeadlineValue={timerDeadlineValue}
        isDesktopProductTileCleanUpDisabled={isDesktopProductTileCleanUpDisabled}
        isMobileWebTileEnhancementEnabled={isMobileWebTileEnhancementEnabled}
        {...props}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const { isBagLoading } = BAG_SELECTORS;
  return {
    orderItems: getCartOrderList(state),
    orderItemsLocal: BAG_SELECTORS.getOrderItemsLocal(state),
    orderAccessorieItems: BAG_SELECTORS.getorderAccessorieItems(state),
    isUserLoggedIn: getUserLoggedInState(state),
    isPlcc: isPlccUser(state),
    isCartItemsUpdating: getIsCartItemsUpdating(state),
    isCartItemSFL: getIsCartItemsSFL(state),
    isSflItemRemoved: getIsSflItemRemoved(state),
    isBagLoading: isBagLoading(state),
    isSflItemMovedToBag: getIsSflItemMovedToBag(state),
    fullPageAuthEnabled: getEnableFullPageAuth(state),
    isNewQVEnabled: true,
    groupedItems: getGroupedItems(state),
    isBossEnabled: sessionSelectors.getIsBossEnabled(state),
    userDefaultStore: PickupSelectors.getUserDefaultPickupStore(state),
    shippingMethodSelected: CheckoutSelector.getSavedShippingMethod(state),
    newBag: true,
    orderEddDates: getOrderEddDates(state),
    orderShipments: getOrderShipments(state),
    updateStoreLoading: getStoreLoadingState(state),
    updateStoreCompleted: getStoreUpadateCompetedState(state),
    LoyaltyPoints: getLoyaltyPointsRequestPayload(state),
    shipmentProductInventory: getshipmentProductInventory(state),
    isBopisEnabled: sessionSelectors.getIsBopisEnabled(state),
    nonBopisData: getNonBopisCartProductIdsWithQty(state),
    isHideMeatBallAbTest: sessionSelectors.getIsHideMeatBallMenuAbTest(state),
    isScrollToTile: getScrollToTile(state),
    isBopisInventorySwitchEnabled: sessionSelectors.getIsBopisInventorySwitch(state),
    hasBopisItems: getHasBopisItems(state),
    isPreOrderItemsIncluded: orderIncludesPreOrderItemsOfItemOrVarientLevel(state),
    isDeleteAnimationEnabled: sessionSelectors.getIsBagPageAnimationEnabled(state),
    initialSFLItemsQty: sessionSelectors.getInitialSFLItemsQty(state),
    rememberedUser: isRememberedUser(state),
    isSocialProofingMsgEnabledApp: sessionSelectors.getSocialProofingMessageApp(state),
    isBossCart: getBossStatus(state),
    bossUnavailableSwitch: sessionSelectors.getBossUnavailableSwitch(state),
    isBossCartPage: getBossStatus(state),
    shipments: getOrderShipments(state),
    freeShippingThershold: getFreeShippingThresholdValue(state),
    shippingTotal: getShippingTotal(state),
    isDynamicFreeShippingEnabled: sessionSelectors.getIsDynamicFreeShippingEnabled(state),
    orderType: getOrderType(state),
    productTotal: getProductTotal(state),
    isSiteWidePromoBannerAbTestEnabled:
      sessionSelectors.getIsSiteWidePromoBannerAbTestEnabled(state),
    isExtendedHolidayReturnsBannerAbTestEnabled:
      sessionSelectors.getIsExtendedHolidayReturnsBannerAbTestEnabled(state),
    isHolidayGetItByMessageBannerAbTestEnabled:
      sessionSelectors.getIsHolidayGetItByMessageBannerAbTestEnabled(state),
    isDefaultSocialProofBanner: BAG_SELECTORS.getDefaultSocialProofBanner(state),
    timerDeadlineValue: sessionSelectors.getDeadlineDateAndTime(state),
    isDesktopProductTileCleanUpDisabled:
      sessionSelectors.getDesktopProductTileCleanUpDisabled(state),
    isSuppressATBModelEnabledApp: sessionSelectors.getIsSuppressATBModelEnabledApp(state),
    isBopisPromoDiscountBannerEnabled: sessionSelectors.getIsBopisPromotionDiscountEnabled(state),
    storeHoursThreshold: sessionSelectors.getStoreHoursThreshold(state),
    isDisplayPickupTimeEnabled: sessionSelectors.getIsDisplayPickupTimeEnabled(state),
    isFullDateDisplayEnabled: sessionSelectors.getIsFullDateDisplayEnabled(state),
    userStore: getDefaultStoreData(state),
    isMobileWebTileEnhancementEnabled: sessionSelectors.getMobileWebProductTileEnhancement(state),
    showBopisTileBasedOnStoreSpecials: sessionSelectors.getShowBopisTileBasedOnStoreSpecials(state),
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    confirmRemoveCartItem: (orderItemId) => {
      dispatch(confirmRemoveCartItem(orderItemId));
    },
    updateCartItem: (itemId, skuId, quantity, itemPartNumber, variantNo) => {
      dispatch(updateCartItem({ itemId, skuId, quantity, itemPartNumber, variantNo }));
    },
    openOverlay: (component) => dispatch(openOverlayModal(component)),
    openModalApplyNowModal: (payload) => dispatch(toggleApplyNowModal(payload)),
    updateStoreItem: (payload) => dispatch(updateStoreItem(payload)),
    setStoreUpdateCompletedState: (payload) => dispatch(setStoreUpdateCompletedState(payload)),
    setScrollToTile: (payload) => dispatch(scrollToTile(payload)),
    getShipmentProductInventory: (payload) => dispatch(getShipmentProductInventoryData(payload)),
    setClickAnalyticsDataDispatch: (payload) => dispatch(setClickAnalyticsData(payload)),
    trackClickDispatch: (payload) => dispatch(trackClick(payload)),
    onPickUpOpenClick: (payload) => {
      dispatch(openPickupModalWithValues(payload));
    },
    updateDeliveryMethodIndex: (payload) => {
      const payloadObj = {
        isFromCart: true,
        deliveryMethodIndex: payload,
      };
      dispatch(updateDeliveryMethodSelection(payloadObj));
    },
    setUserDefaultStore: (payload) => {
      if (payload?.storeBossInfo?.endDate && payload?.storeBossInfo?.startDate) {
        dispatch(setDefaultStore(payload));
      }
    },
    moveItemsToBossUnavailableListAction: (payload) => {
      dispatch(moveItemsToBossUnavailableList(payload));
    },
    setBossUnavailableProductInListAction: (payload) => {
      dispatch(setBossUnavailableProductInList(payload));
    },
    setDefaultBannerAction: (payload) => {
      dispatch(setDefaultBanner(payload));
    },
  };
};

ProductTileWrapperContainer.defaultProps = {
  orderItems: [],
  pageView: '',
  fullPageAuthEnabled: false,
  orderShipments: [],
  isMiniBag: false,
  isBopisEnabled: false,
};

ProductTileWrapperContainer.propTypes = {
  orderItems: PropTypes.shape([]),
  initialActions: PropTypes.func.isRequired,
  pageView: PropTypes.string,
  fullPageAuthEnabled: PropTypes.bool,
  orderShipments: PropTypes.shape([]),
  isMiniBag: false,
  isBopisEnabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductTileWrapperContainer);
